module OfficeExt {
  export interface ShortcutKeyPlatformAvailability {
    web?: string;
    default?: string;
  }
  export interface ExtendedManifestShortcut {
    action: string;
    key: ShortcutKeyPlatformAvailability;
  }
  export interface ExtendedManifestAction {
    id: string;
    type?: string;
    name: string;
  }
  export interface ExtendedManifestResources {
    [id: string]: {
      value: string;
      comment: string;
    };
  }
  export interface ExtendedManifest {
    shortcuts?: ExtendedManifestShortcut[];
    actions?: ExtendedManifestAction[];
    resources?: {
      default: ExtendedManifestResources;
    };
  }
}
